export const breakpoints = {
  podiumCdsBreakpointXs: "320px",
  podiumCdsBreakpointS: "600px",
  podiumCdsBreakpointM: "960px",
  podiumCdsBreakpointL: "1440px",
  podiumCdsBreakpointXl: "1920px",
};
